import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SectionCard } from "../components/SectionCard";
import { useSetTrail } from "../context/BreadcrumbContext";
import { api, notify } from "../lib/api";

export function AdminUserFormPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pseudo, setPseudo] = useState("");
  const [role, setRole] = useState<"player" | "admin">("player");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useSetTrail([
    { label: "Utilisateurs", to: "/admin" },
    { label: "Ajouter un utilisateur" },
  ]);

  useEffect(() => {
    let active = true;
    void api
      .getAdminPlayerDefaults()
      .then((defaults) => {
        if (active) setPseudo(defaults.pseudo);
      })
      .catch(() => {})
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (submitting || loading) return;
    const trimmedPseudo = pseudo.trim();
    if (trimmedPseudo && trimmedPseudo.length < 2) {
      notify("error", "Le pseudo doit contenir au moins 2 caractères");
      return;
    }
    setSubmitting(true);
    void api
      .adminCreatePlayer({
        email: email.trim().toLowerCase(),
        pseudo: trimmedPseudo || undefined,
        role,
      })
      .then(() => {
        notify("success", "Utilisateur créé et email de connexion envoyé");
        navigate("/admin");
      })
      .catch(() => {})
      .finally(() => setSubmitting(false));
  }

  return (
    <div className="sm:max-w-lg">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-ink">Ajouter un utilisateur</h1>
        <p className="mt-2 text-sm text-smoke">
          Un email contenant un lien de première connexion sera envoyé à cette
          adresse.
        </p>
      </div>

      <form className="space-y-5" onSubmit={handleSubmit}>
        <SectionCard title="Informations">
          <fieldset className="space-y-4" disabled={submitting}>
            <div>
              <label className="label" htmlFor="user-email">
                Email leboncoin
              </label>
              <input
                id="user-email"
                type="email"
                className="text-field"
                autoComplete="email"
                placeholder="prenom.nom@leboncoin.fr"
                required
                maxLength={255}
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
            <div>
              <label className="label" htmlFor="user-pseudo">
                Pseudo (facultatif)
              </label>
              <input
                id="user-pseudo"
                type="text"
                className="text-field"
                autoComplete="off"
                minLength={2}
                maxLength={40}
                disabled={loading}
                aria-describedby="user-pseudo-help"
                value={pseudo}
                onChange={(event) => setPseudo(event.target.value)}
              />
              <p id="user-pseudo-help" className="mt-1 text-xs text-smoke">
                {loading
                  ? "Génération du pseudo..."
                  : "Un pseudo unique sera généré si ce champ est vide."}
              </p>
            </div>
            <div>
              <label className="label" htmlFor="user-role">
                Rôle
              </label>
              <select
                id="user-role"
                className="text-field"
                value={role}
                onChange={(event) =>
                  setRole(event.target.value as "player" | "admin")
                }
              >
                <option value="player">Joueur</option>
                <option value="admin">Admin</option>
              </select>
            </div>
          </fieldset>
        </SectionCard>
        <div className="flex items-center justify-end gap-3">
          {!submitting && (
            <Link className="btn-secondary" to="/admin">
              Annuler
            </Link>
          )}
          <button
            type="submit"
            className="btn-primary"
            disabled={loading || submitting}
          >
            {submitting ? "Envoi en cours..." : "Créer et envoyer l’email"}
          </button>
        </div>
      </form>
    </div>
  );
}
